import * as Dialog from '@radix-ui/react-dialog';

import ContactEdit from '../CandidateForm/ContactEdit';
import RegisterEdit from '../CandidateForm/RegisterEdit';
import PersonalData1 from '../CandidateForm/PersonalData1';
import PersonalData2 from '../CandidateForm/PersonalData2';
import ProfessionalData1 from '../CandidateForm/ProfessionalData1';
import ProfessionalData2 from '../CandidateForm/ProfessionalData2';
import ProfessionalDataEducation from '../CandidateForm/ProfessionalDataEducation';
import ProfessionalData4 from '../CandidateForm/ProfessionalData4';
import ProfessionalDataExperience from '../CandidateForm/ProfessionalDataExperience';
import DisabilityDataIndex from '../CandidateForm/DisabilityDataIndex';
import DisabilityData from '../CandidateForm/DisabilityData';
import DisabilityDataDescription from '../CandidateForm/DisabilityDataDescription';
import DisabilityDataUpload from '../CandidateForm/DisabilityDataUpload';
import Icon from '@egalite/ui/Icon';

import { useParams, usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import Button from '@egalite/ui/Buttons';
import Typography from '@egalite/ui/Typography';

const EditDialog = ({ fetchCandidate = () => {}, message = null }) => {
	const router = useRouter();
	const searchParams = useSearchParams();
	const pathname = usePathname();

	const closeModal = useCallback(() => {
		const params = new URLSearchParams(searchParams.toString());
		params.delete('modal');
		params.delete('id');
		router.replace(`${pathname}?${params.toString()}`);
	}, [pathname, router, searchParams]);

	const mapForms = useMemo(
		() => ({
			contact: () => (
				<ContactEdit
					//@ts-ignore
					edit={true}
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
            register: () => (
				<RegisterEdit
					//@ts-ignore
					edit={true}
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
			personal1: () => (
				<PersonalData1
					//@ts-ignore
					edit={true}
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
			personal2: () => (
				<PersonalData2
					//@ts-ignore
					edit={true}
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
			professional1: () => (
				<ProfessionalData1
					edit={true}
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
			professional2: () => (
				<ProfessionalData2
					edit={true}
					//@ts-ignore
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
			professional4: () => (
				<ProfessionalData4
					edit={true}
					//@ts-ignore
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
			education: () => (
				<ProfessionalDataEducation
					edit={true}
					//@ts-ignore
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
			experience: () => (
				<ProfessionalDataExperience
					edit={true}
					//@ts-ignore
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
			disabilityIndex: () => (
				<DisabilityDataIndex
					edit={true}
					//@ts-ignore
					root={pathname}
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
			disability: () => (
				<DisabilityData
					edit={true}
					//@ts-ignore
					root={pathname}
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
			disabilityDescription: () => (
				<DisabilityDataDescription
					edit={true}
					//@ts-ignore
					root={pathname}
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
			disabilityUpload: () => (
				<DisabilityDataUpload
					edit={true}
					//@ts-ignore
					root={pathname}
					onSuccess={() => {
						closeModal();
						fetchCandidate();
					}}
				/>
			),
		}),
		[closeModal, fetchCandidate, pathname],
	);

	return (
		<Dialog.Root
			open={searchParams.get('modal') != null}
			onOpenChange={open => {
				if (open === false) {
					closeModal();
				}
			}}
		>
			<Dialog.Overlay className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 z-40" />
			<Dialog.Content className="fixed top-10 bottom-4 left-1/2 -translate-x-1/2 bg-white rounded-3xl pt-10 md:top-20 md:bottom-14 w-11/12 max-w-6xl z-50">
				<div className="overflow-x-hidden overflow-y-auto h-full w-full">
                    {message ? <Typography  variant="headline-4" className="p-12 mt-8 mb-8">{message}</Typography> : null}
					{mapForms[searchParams.get('modal')] != null && mapForms[searchParams.get('modal')]()}
				</div>
				<Dialog.Close asChild>
					<Button
						variant="secondary"
						type="button"
						className="rounded-full p-2 w-20 h-20 bg-white fixed -right-4 sm:-right-8 -top-8 z-[51] border-2"
					>
						<Icon className="fi fi-br-cross" />
					</Button>
				</Dialog.Close>
			</Dialog.Content>
		</Dialog.Root>
	);
};

export default EditDialog;
